import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CONSTANTS } from '../../../../constants';
import { CommonModule } from '@angular/common';
import { PoWidgetModule, PoTagModule, PoTagType } from '@po-ui/ng-components';
import { Router } from '@angular/router';
import { InventoryCountModel } from '../../../../models/inventory-count.model';

@Component({
  selector: 'app-inventory-count-card',
  imports: [PoWidgetModule, PoTagModule, CommonModule],
  templateUrl: './inventory-count-card.component.html',
  styleUrl: './inventory-count-card.component.css'
})
export class InventoryCountCardComponent {
  @Input() inventoryCounts: InventoryCountModel[] | undefined;
  @Output() inventoryCountSelected = new EventEmitter<InventoryCountModel>();
  statusLabels = CONSTANTS.INVENTORY_STATUS;
  colorsStatusLabels = CONSTANTS.INVENTORY_COUNT_STATUS_COLORS;

  constructor(private router: Router) { }
  
  openDetail(item: InventoryCountModel) {
    this.inventoryCountSelected.emit(item);
  }

  getStatusLabel(status: number): string {
    return (CONSTANTS.INVENTORY_STATUS as Record<number, string>)[status] || 'Desconhecido';
  }

  getStatusColor(value: number): PoTagType {
    return CONSTANTS.INVENTORY_COUNT_STATUS_COLORS[value as keyof typeof CONSTANTS.INVENTORY_COUNT_STATUS_COLORS] ?? PoTagType.Neutral;
  }
}
